import { HTMLAttributes, ReactElement } from 'react';
import { colorFillColor, fontTypo } from 'mt-react-theme-manager';

import Icon from '../Icon';

import './styles.scss';

interface EmailLabel extends HTMLAttributes<HTMLDivElement> {
  email: string;
  includeHiddenInput?: boolean;
}

export default function EmailLabel({
  email,
  includeHiddenInput = false,
  className = '',
  ...rest
}: EmailLabel): ReactElement {
  return (
    <div className={`email-label ${className}`} {...rest}>
      <Icon
        className={`envelope-icon ${colorFillColor('primary', 'base')}`}
        icon="message"
        data-testid="email-label-envelope-icon"
      />
      <span className={`email ${fontTypo('headline')}`}>{email}</span>
      {includeHiddenInput && (
        <input type="hidden" name="guest[email]" value={email} />
      )}
    </div>
  );
}
